import React, { Component, Fragment } from 'react';
import { Field, FormSpy } from 'react-final-form';
import { Form } from 'antd';
import Translate from 'react-translate-component';

import {
    yesnocombo,
    metroHQ,
    metroGrades,
    metroPositionLevels,
    metroBonusSchema,
    metroCompanyCar,
    metroBonusPercent,
} from 'constants/dictionaries';
import {
    METRO_REQUEST_CURRENT,

    METRO_REQUEST_MGL,
    METRO_REQUEST_HQ,
    METRO_REQUEST_STORE,

    METRO_REQUEST_ROUTES_FILTERS,
} from 'constants/metro';
import { wrapCellFormItem } from 'constants/formItemLayout';
import Text from 'components/common/form/Text';
import { SelectLoadComponent } from 'components/common/form/Select';
import { RadioButtonsLoad } from 'components/common/form/RadioButtons';
import Switch from 'components/common/form/Switch';

export default class PositionFields extends Component {
    render() {
        const { disabled, isApproval, requestType, positionCode, cellId, positionCodeForCopy } = this.props;

        const isCurrent = requestType === METRO_REQUEST_CURRENT;
        const enableChangePosition = !!(isCurrent || positionCode || positionCodeForCopy) && !isApproval;

        return <Fragment>
            <hr />
            <FormSpy>
                { ({ values }) => values.changePosition && enableChangePosition ? (
                    <Field
                        name='changePosition'
                        component={Switch}
                        label={{ content: 'metro.request.changePosition' }}
                        disabled={disabled}
                        onChange={this.props.onChangePosition}
                    />
                ) : null}
            </FormSpy>

            { !isApproval && (cellId || positionCodeForCopy) ? (
                <FormSpy>
                    { ({ values }) => values.changePosition ? (
                        <Form.Item wrapperCol={wrapCellFormItem}>
                            <Translate content='metro.request.changePositionDescription' />
                        </Form.Item>
                    ) : null}
                </FormSpy>
            ) : null}

            { this.renderPositionFields()}

            <hr />
        </Fragment>;
    }

    renderPositionFields = () => {
        const { disabled, isNew, isApproval, editPosition, positionDisabled } = this.props;
        const { routeType, requestType } = this.props;

        const isStore = routeType === METRO_REQUEST_STORE;

        return (
            <Fragment>
                <Field
                    name='positionCostCenters'
                    component={Text}
                    label={{ content: 'metro.request.positionCostCenters' }}
                    disabled={!editPosition}
                />

                { routeType === METRO_REQUEST_HQ && (
                    <Field
                        name='HQ'
                        component={SelectLoadComponent}
                        loadName={metroHQ}
                        label={{ content: 'metro.request.HQ' }}
                        valuePath='name'
                        disabled={positionDisabled}
                        allowClear
                    />
                )}
                <Field
                    name='positionGradeCode'
                    component={SelectLoadComponent}
                    loadName={metroGrades}
                    label={{ content: 'metro.request.positionGrade' }}
                    disabled={positionDisabled}
                    allowClear
                />
                { routeType && requestType && (
                    <Field
                        name='positionLevelCode'
                        component={SelectLoadComponent}
                        loadName={metroPositionLevels}
                        loadParams={{
                            type: METRO_REQUEST_ROUTES_FILTERS[routeType],
                        }}
                        label={{ content: 'metro.request.positionLevel' }}
                        disabled={positionDisabled}
                        allowClear
                    />
                )}
                <Field
                    name='bonusSchemeCode'
                    component={SelectLoadComponent}
                    loadName={metroBonusSchema}
                    label={{ content: 'metro.request.bonusScheme' }}
                    disabled={positionDisabled}
                    allowClear
                />
                <Field
                    name='bonusSchemePercentCode'
                    component={SelectLoadComponent}
                    loadName={metroBonusPercent}
                    label={{ content: 'metro.request.bonusSchemePercent' }}
                    disabled={positionDisabled}
                    allowClear
                />
                <Field
                    name='familyDMSCode'
                    component={RadioButtonsLoad}
                    loadName={yesnocombo}
                    label={{ content: 'metro.request.familyDMS' }}
                    disabled={positionDisabled}
                />
                <Field
                    name='companyCarCode'
                    component={SelectLoadComponent}
                    loadName={metroCompanyCar}
                    label={{ content: 'metro.request.companyCar' }}
                    disabled={positionDisabled}
                    allowClear
                />
                { isStore && (
                    <Fragment>
                        <Field
                            name='accessToPCCode'
                            component={RadioButtonsLoad}
                            loadName={yesnocombo}
                            label={{ content: 'metro.request.accessToPC' }}
                            disabled={disabled}
                        />
                    </Fragment>
                )}
                {(routeType === METRO_REQUEST_MGL || isNew || isApproval) && (
                    <Fragment>
                        <Field
                            name='travellingWorkCode'
                            component={RadioButtonsLoad}
                            loadName={yesnocombo}
                            label={{ content: 'metro.request.travellingWork' }}
                            disabled={positionDisabled}
                        />
                        <Field
                            name='liabilityContractCode'
                            component={RadioButtonsLoad}
                            loadName={yesnocombo}
                            label={{ content: 'metro.request.liabilityContract' }}
                            disabled={positionDisabled}
                        />
                    </Fragment>
                )}

                { isApproval && (
                    <Fragment>
                        <Field
                            name='positionBudgetedCode'
                            component={RadioButtonsLoad}
                            loadName={yesnocombo}
                            label={{ content: 'metro.request.positionBudgeted' }}
                            disabled={true}
                        />
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

